<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您所輸入的資料將不會被保留。" content_2="是否確認退出？"></QuitButton>
      <BackButton back_url="login"></BackButton>
    </FabColumn>

    <ion-content>
      <MainTitle text="忘記密碼"></MainTitle>
      <InputBox text="手提電話號碼" placeholder="請輸入手提電話號碼" type="number" @getValue="getMobile"></InputBox>
      <ConfirmButton text="繼續" position="relative" @click="resetPassword"></ConfirmButton>
    </ion-content>

  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import QuitButton from "../components/common/QuitButton";
import BackButton from "../components/common/BackButton";
import MainTitle from "../components/common/MainTitle";
import ConfirmButton from "../components/common/ConfirmButton";
import common from "../common";
import router from "../router";
import InputBox from "../components/common/InputBox";

export default {
  name: "ForgetPasswordByMobile",
  components: {
    InputBox,
    ConfirmButton,
    MainTitle,
    BackButton,
    QuitButton,
    WhiteBackground,
    Background,
    IonPage,
    IonContent,
  },
  data() {
    return {
      mobile: '',
    }
  },
  methods: {
    getMobile: function (value) {
      this.mobile = value;
    },
    resetPassword: function () {
      if (!this.mobile) {
        common.showAlert('請輸入手提電話號碼。');
        return;
      }

      const loading = common.showLoading();
      common.apiPostData('/resetPasswordVerifyMobile', {mobile: this.mobile}, false, loading).then(res => {
        if (res === false) {
          return false;
        }

        router.replace('/mobileVerify/'+this.mobile+'/forgetPasswordByMobile');

      });
    }
  }
}
</script>

<style scoped>

</style>
